// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aviation-document-obligations.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aviation-document-obligations/aviation-document-obligations.js';

mount([g0]);
